import { useEffect, useState } from "react";
import { apiServices } from "../../../../core/utilities/ApiServices";
import { User } from "../../../../core/icons/User";

const PROTECTED_THUMBNAIL_PATH = /^\/match\/likes-you-thumbnail\/[A-Za-z0-9_-]+(?:\?v=\d+)?$/;

export const ProtectedLikeThumbnail = ({ thumbnailUrl }: { thumbnailUrl: string }) => {
	const [imageUrl, setImageUrl] = useState<string>();
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		let active = true;
		let temporaryUrl = "";
		setImageUrl(undefined);
		setHasError(false);
		if (!PROTECTED_THUMBNAIL_PATH.test(thumbnailUrl)) {
			setHasError(true);
			return;
		}

		void apiServices
			.get<Blob>(thumbnailUrl, { responseType: "blob" })
			.then((response) => {
				const contentType = response.headers?.["content-type"] || response.data.type;
				if (contentType?.split(";")[0].trim().toLowerCase() !== "image/jpeg") {
					throw new Error("Invalid protected thumbnail response");
				}
				temporaryUrl = URL.createObjectURL(response.data);
				if (active) setImageUrl(temporaryUrl);
			})
			.catch(() => {
				if (active) setHasError(true);
			});

		return () => {
			active = false;
			if (temporaryUrl) URL.revokeObjectURL(temporaryUrl);
		};
	}, [thumbnailUrl]);

	return (
		<div className="relative h-24 w-24 shrink-0 overflow-hidden rounded-xl bg-gray-200" aria-label="Hidden like preview">
			{imageUrl && !hasError ? (
				<img
					className="h-full w-full object-cover"
					src={imageUrl}
					alt="Heavily blurred hidden like"
					draggable={false}
				/>
			) : (
				<div className="absolute inset-0 flex items-center justify-center">
					{hasError ? (
						<User className="h-10 w-10 text-gray-400" />
					) : (
						<div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-primary" />
					)}
				</div>
			)}
		</div>
	);
};
